import React, { useEffect } from 'react';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import TopLogoBar from "./components/Header/TopLogoBar/TopLogoBar";
import Navbar from "./components/Header/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

import Home from "./pages/Home/index";
import About from "./pages/AboutUs/aboutUs";
import Founder from "./pages/Founder/Founder";
import Contact from "./pages/ContactUs/contactUs";
import AccreditationsDetails from "./components/AccreditationsDetails/AccreditationsDetails";
import Departments from './pages/Departments/Departments';
import TeastingPage from './pages/TestingPage/TestingPage';
import FacultyDetails from './pages/FacultyDetails/FacultyDetails';

function App() {
      useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration (ms)
      easing: 'ease-in-out', // easing style
      once: true, // whether animation should happen only once
      mirror: false, // whether elements animate out while scrolling past
    });
  },[]);
  return (
    <BrowserRouter>
      <TopLogoBar />
      <Navbar />
      
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/founder" element={<Founder />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/FacultyDetails/:id" element={<FacultyDetails />} />

        <Route path="/contact-us" element={<Contact />} />
        <Route path="/accreditations-details" element={<AccreditationsDetails />} />

        <Route path="/testing-page" element={<TeastingPage />} />

      </Routes>

      <Footer />
    
    </BrowserRouter>
  );
}

export default App;
